import { Component } from '@angular/core';
import {NavController, NavParams, PopoverController, ViewController} from 'ionic-angular';
import { PollProvider } from '../../../providers/poll/poll';


@Component({
  selector: 'poll-page',
  templateUrl: 'poll.html',
})
export class PollPage {

  pollList: any = [];
  answeredPollList: any = [];
  answers: any = [];
  radioGroupPlaceHolder: any = [] // used to change the default radio button behavior

  userAnswers = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public popoverCtrl: PopoverController,
    public pollProvider: PollProvider,
    private viewCtrl: ViewController) {
  }

  ionViewWillEnter() {
    this.loadPolls();
  }


  loadPolls() {
    this.pollList = []
    this.answeredPollList = []

    this.pollProvider.getAll().subscribe((res) => {
      if (res.success) {
        res.data.forEach(poll => {
          if(poll.answered[0] == false){
            this.pollList.push(poll)
          }else{
            this.answeredPollList.push(poll)
          }


          this.answers[poll.id] = {
            options: [],
            string: '',
          };

            poll.Options.forEach(option => {
              this.answers[poll.id].options[option.option] = false;
            })
            this.answers[poll.id].string = null;

        });
        this.pollList.forEach(() => {
          this.userAnswers.push([]);
        });
      }
    })
  }

  doRefresh(refresher) {
    this.loadPolls();
    setTimeout(() => {
      refresher.complete();
    }, 1000);
  }

  checkHandle(currPollId, currOption, e, multiAnswer, pollIndex) {
    if (multiAnswer) {
      if (this.userAnswers[pollIndex].includes(currOption)) {
        this.userAnswers[pollIndex] = this.userAnswers[pollIndex].filter(s => s !== currOption);
      }
      else {
        this.userAnswers[pollIndex].push(currOption);
      }
    }
    else {
      Object.keys(this.answers[currPollId].options).forEach((answers) => { // If multi answers is disabled, then uncheck everything and then check de new answer
        this.answers[currPollId].options[answers] = false;
      });
      if(this.userAnswers[pollIndex][0]) {
        this.userAnswers[pollIndex][0] = currOption;
      }
      else {
        this.userAnswers[pollIndex].push(currOption);
      }
    }
    this.answers[currPollId].options[currOption] = e.checked; // Handle checkbox true false

    console.log(this.userAnswers[pollIndex]);
  }

  sendVote(id, type, pollIndex) {

    let votePayload = {
      options: [],
      answer_string: null
    }

    if (type == 4) { // If Type 4, then we don't need options but only answer string, otherwise use options
      votePayload.answer_string = this.answers[id].string
      votePayload.options = ['cst']
    }

    else if (type == 2) { // If type 2, then we want both, options and string
      votePayload.answer_string = this.answers[id].string
      let currOptions = this.userAnswers[pollIndex];
      // Object.keys(this.answers[id].options).forEach((answers) => { // Get checked answers for this poll
      //   this.answers[id].options[answers] == true ? currOptions.push(answers) : '';
      // })
      votePayload.options = currOptions
      if (currOptions.length == 0) {
        return
      }
    }


    else {
      let currOptions = this.userAnswers[pollIndex];
      // Object.keys(this.answers[id].options).forEach((answers) => { // Get checked answers for this poll
      //   this.answers[id].options[answers] == true ? currOptions.push(answers) : '';
      // })
      votePayload.options = currOptions
      if (currOptions.length == 0) {
        return
      }
    }

    console.log('Result = ');
    console.log(votePayload);

    this.pollProvider.vote(id, votePayload).subscribe((res) => {
      if (res.success) { this.loadPolls() }
    })

  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/employee/poll/poll.ts